import React from 'react'

const SvgStrollerFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M19 10c.552 0 1.007.45.938.998a8.002 8.002 0 01-15.876 0C3.993 10.45 4.448 10 5 10h14z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 22a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.666a.833.833 0 100-1.667.833.833 0 000 1.666zM18.5 22a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.666a.833.833 0 100-1.667.833.833 0 000 1.666zM2 5a1 1 0 011-1h2.5A1.5 1.5 0 017 5.5V8H5V6H3a1 1 0 01-1-1z'
    />
    <path d='M19 10c.552 0 1.007.45.938.998a8.002 8.002 0 01-15.876 0C3.993 10.45 4.448 10 5 10h14z' />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M5.5 22a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.666a.833.833 0 100-1.667.833.833 0 000 1.666zM18.5 22a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm0-1.666a.833.833 0 100-1.667.833.833 0 000 1.666zM2 5a1 1 0 011-1h2.5A1.5 1.5 0 017 5.5V8H5V6H3a1 1 0 01-1-1z'
    />
    <path d='M14.016 2h-2.462a.47.47 0 00-.463.547l.773 4.618a1 1 0 00.987.835h1.165V2zM16.016 8H19c.552 0 1.009-.45.918-.996a6.008 6.008 0 00-3.902-4.657V8z' />
  </svg>
)

export default SvgStrollerFilled
